import theme from 'kb-shared/theme';
import styled from 'styled-components';

export const UnreadMessagesIconContainer = styled.div`
  margin-top: -15px;
  margin-left: -20px;
  position: absolute;

  @media ${({ theme }) => theme.queries.mobile} {
    display: none;
  }
`;

export const UnreadMessagesContainer = styled.div`
  border-radius: 16px;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.card.level2};
  padding: 1em 3em 1em 3em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  > h2 {
    margin-left: 40px;
  }

  > button {
    max-width: 500px;
  }

  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    flex-direction: column;
    justify-content: center;
    text-align: center;

    > button {
      margin-top: 1em;
      width: 100%;
    }

    > h2 {
      margin-left: 0;
    }
  }

  @media ${({ theme }) => theme.queries.mobile} {
    padding: 4em 1.5em;
    border-bottom: ${theme.colors.yellow.primary};
    background: ${theme.colors.yellow.primary};
    border-radius: 0;
    box-shadow: none;
    background-image: url("data:image/svg+xml,%3Csvg width='240' height='192' viewBox='0 0 240 192' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3EUnread Messages%3C/title%3E%3Cpath opacity='0.48' d='M156.078 65.9384C156.078 102.654 120.861 131.877 78.1512 131.877C63.5399 131.877 50.4272 128.88 38.813 122.885C29.4468 127.756 17.458 131.877 2.84662 131.877C1.72267 131.877 0.598719 131.502 0.224069 130.378C-0.15058 129.254 -0.150581 128.13 0.973368 127.381C0.973368 127.006 9.59032 118.015 15.5847 105.651C5.84382 94.4118 0.224069 80.9244 0.224069 65.9384C0.224069 29.5973 35.0665 0 78.1512 0C120.861 0 156.078 29.5973 156.078 65.9384ZM78.1512 125.882C117.489 125.882 150.084 99.2822 150.084 65.9384C150.084 32.9692 117.489 5.9944 78.1512 5.9944C38.4384 5.9944 6.21847 32.9692 6.21847 65.9384C6.21847 79.0511 11.0889 91.0399 20.0805 101.53L22.7031 104.527L20.8298 108.274C17.458 115.392 12.9622 121.387 9.96497 125.508C18.9566 124.758 27.5735 122.136 36.1905 117.64L38.813 116.141L41.4356 117.64C52.6751 123.26 65.0385 125.882 78.1512 125.882ZM224.639 166.345C230.634 178.333 238.876 186.95 238.876 187.325C239.625 188.074 240 189.198 239.625 190.322C239.251 191.446 238.127 191.821 237.003 191.821C223.515 191.821 211.901 188.074 202.535 183.953C192.419 188.824 180.431 191.821 168.067 191.821C137.721 191.821 112.244 174.962 101.38 150.984C100.63 149.485 101.754 147.237 103.253 146.863H103.627C104.751 146.488 106.25 147.237 106.999 148.736C116.74 170.466 140.343 185.826 168.067 185.826C178.932 185.826 190.172 183.204 199.912 178.333L202.535 177.209L205.158 178.333C213.4 182.454 221.642 184.702 229.884 185.826C226.887 181.705 222.766 175.711 219.394 169.342L217.521 165.595L220.144 162.598C229.135 152.108 234.006 139.37 234.006 125.882C234.006 95.5357 208.904 70.4342 176.31 66.6877C174.811 66.313 174.062 65.1891 173.687 64.0651C173.687 62.1919 175.186 60.6933 177.059 60.6933C212.651 64.8144 240 92.5385 240 125.882C240 141.243 234.006 155.105 224.639 166.345Z' fill='%23F1CB0A'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: top 16px left 50%;

    > button {
      margin-top: 1.5em;
      width: 100%;
    }
  }
`;

export const Container = styled.div`
  padding: 0;

  @media ${({ theme }) => theme.queries.tablet} {
    padding: 2em 1.5em 1em 1.5em;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    padding: 2em 0 0 0;
    margin-bottom: 0.5em;
  }
`;
